import { createFileRoute } from '@tanstack/react-router';

import { LoginPageWidget } from '@features/auth/pages/LoginPage';

export const Route = createFileRoute('/login')({
  component: Page,
  validateSearch: (search) => {
    return {
      back: search?.back,
    } as { back?: string };
  },
});

function Page() {
  const search = Route.useSearch();
  return <LoginPageWidget redirect={search.back} />;
}
